import { ApiService } from '~/services/api/api'

export class SuperUserService {
  private readonly apiService = new ApiService()

  async requestAppUpdateRefresh() {
    const response = await this.apiService.post<undefined, undefined>(
      '/app-update-refresh',
      undefined,
    )
    return response
  }

  async getActiveConnections() {
    const response = await this.apiService.get<Record<string, string[]>>(
      '/workspaces-sse/1234/connections',
    )
    return response
  }
}
